function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import { HeaderRenderer } from './HeaderRenderer';

/**
 * Hook to enhance columns with filtering headers and row expansion support
 * 
 * @param {Array} columns - Base column definitions
 * @param {boolean} enableFiltering - Whether filtering is enabled
 * @param {Object} filters - Current filter state
 * @param {Function} updateFilter - Callback to update filters
 * @param {boolean} enableRowExpansion - Whether row expansion is enabled
 * @param {Function} toggleRowExpansion - Callback to toggle row expansion
 * @param {Function} isRowExpandable - Function to check if row is expandable
 * @param {string} expandedRowProp - Property name for expansion state
 * @param {boolean} showHeaderFilters - Whether filter controls should render inside headers
 * @returns {Array} Enhanced columns
 */
export function useDataGridColumns(columns, enableFiltering, filters, updateFilter, enableRowExpansion, toggleRowExpansion, isRowExpandable, expandedRowProp) {
  let showHeaderFilters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
  return useMemo(() => {
    let result = columns;

    // Add filtering support
    if (enableFiltering) {
      result = result.map(column => {
        // If column already has renderHeaderCell, don't override
        if (column.renderHeaderCell) {
          return column;
        }

        // Add HeaderRenderer for filtering
        return _objectSpread(_objectSpread({}, column), {}, {
          renderHeaderCell: props => /*#__PURE__*/React.createElement(HeaderRenderer, _extends({}, props, {
            filters: filters,
            onFilterChange: updateFilter,
            showFilter: showHeaderFilters
          }))
        });
      });
    }

    // Add row expansion support - make toggle function available to all columns
    if (enableRowExpansion) {
      result = result.map(column => _objectSpread(_objectSpread({}, column), {}, {
        toggleRowExpansion,
        isRowExpandable,
        expandedRowProp
      }));
    }
    return result;
  }, [columns, enableFiltering, filters, updateFilter, enableRowExpansion, toggleRowExpansion, isRowExpandable, expandedRowProp, showHeaderFilters]);
}